<template lang="html">

<section class="webinarios pad-sec">
      <div class="container flex wrap">
        <div class="col-50">
          <h2 class="title title-36">{{$t('area_tecnica.webinarios.titulo')}}</h2>
          <p>{{$t('area_tecnica.webinarios.texto')}}</p>
          <router-link class="btn btn-dark -yellow-full" :to="`/${$t('enlaces.contacto')}`">{{ $t('area_tecnica.webinarios.btn') }}</router-link>
<!--           <h3 class="title title-26">{{$t('area_tecnica.webinarios.proximos')}}</h3>
          <div class="evento flex row">
            <div>
              <p>{{$t('area_tecnica.webinarios.no_hay')}}</p>
            </div>
          </div> -->
          <!--MAQUETACIÓN EVENTOS WEBINARIOS OCULTA-->
          <!-- <div class="evento flex row">
            <div>
              <img src="img/calendar.svg" alt=""/>
            </div>
            <div>
              <p>Jueves 11 de mayo de 2018</p>
              <p>{{$t('area_tecnica.webinarios.hasta')}}</p>
              <a class="go" href="contacto.html">{{$t('area_tecnica.webinarios.anadir_cal')}}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
            </div>
          </div> -->
        </div>
        <div class="col-50">
          <h2 class="title title-36">{{$t('area_tecnica.webinarios.ultimo')}}</h2>
          <div class="col-100">
            <div class="img-video" data-value="video-1">
              <a class="play open-pop"></a>
            </div>
            <a class="link-video open-pop" href="javascript:void(0)">Assembly Oil Feed Pipe / Montaje Tubo de Engrase VOLKSWAGEN PASSAT 2.0 TDI 16V (CBDC)</a>
          </div>
        </div>
      </div>
    </section>

</template>

<script lang="js">
  export default  {
    name: 'webinarios',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/view-parts/area-tecnica/webinarios.vue